module.exports = __webpack_public_path__ + "static/media/man-right.9a5dd14e.png";